const state = () => ({
    roomInfo:true,
    roomManagement: true,
    roomType: true
})
const getters = {
    roomInfo: (state) => state.roomInfo,
    roomManagement: (state) => state.roomManagement,
    roomType: (state) => state.roomType,
}
const mutations = {

    setRoomInfo(state, roomInfo) {
        state.roomInfo = roomInfo
    },
    setRoomManagement(state, roomManagement) {
        state.roomManagement = roomManagement
    },
    setRoomType(state, roomType) {
        state.roomType = roomType
    },

}
const actions = {
    setRoomInfo({ commit }, roomInfo) {
        commit('setRoomInfo', roomInfo)
    },
    setRoomManagement({ commit }, roomManagement) {
        commit('setRoomManagement', roomManagement)
    },
    setRoomType({ commit }, roomType) {
        commit('setRoomType', roomType)
    },

}
export default {
    state,
    getters,
    mutations,
    actions,
}


// WEBPACK FOOTER //
// ./src/store/modules/roomChangeStatus.js